<div class="footer">
  <div id="copyright">
    <strong>Copyright</strong> R2 Innovative Technologies &copy; 2011-2025
  </div>
  <div id="version">
    App: {{ appVersion }} | API: {{ apiVersion }} | API URL: {{ apiBasePath }}
  </div>
</div>
